<div>
  <h3>{{ name }}</h3>
  <p>{{ 'Booking date' | translate }}: {{ bookingDate }}</p>
</div>
<div *ngIf="orderLines" class="mb-4">
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">{{ 'Product' | translate }}</th>
        <th scope="col" *ngIf="isEndDateHide"><span *ngIf="!isGiftCardOrderType">{{ 'Date' | translate }}</span></th>
        <th scope="col" *ngIf="!isEndDateHide"><span *ngIf="!isGiftCardOrderType">{{ 'Event Date Start' | translate }}</span></th>
        <th scope="col" *ngIf="!isEndDateHide"><span *ngIf="!isGiftCardOrderType">{{ 'Event Date End' | translate }}</span></th>
        <th scope="col">{{ 'Quantity' | translate }}</th>
        <th scope="col">{{ 'Price' | translate }}</th>
        <th scope="col">{{ 'Sum' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let orderLine of orderLines">
        <td scope="row">{{ orderLine.name | translate }}</td>
        <td><span *ngIf="!isGiftCardOrderType">{{ formatDatetime(orderLine.eventDateStart) || ''}}</span></td>
        <td *ngIf="!isEndDateHide"><span *ngIf="!isGiftCardOrderType">{{ formatDatetime(orderLine.eventDateEnd) || '' }}</span></td>
        <td>{{ orderLine.quantity }} x</td>
        <td>{{ toMoneyStr(orderLine.price) }}</td>
        <td>{{ toMoneyStr(orderLine.price * orderLine.quantity) }}</td>
      </tr>
      <tr *ngFor="let coupon of coupons">
        <td scope="row">{{ coupon.name }}</td>
        <td>1 x</td>
        <td>-{{ toMoneyStr(coupon.amount) }}</td>
        <td>-{{ toMoneyStr(coupon.amount) }}</td>
      </tr>
    </tbody>
  </table>
</div>
<div class="row">
  <section class="col">
    <div class="row justify-content-between">
      <div class="col-12 col-md-4">
        <app-button [title]="'Back' | translate" (clickEvent)="onBackwardClick()" [isLeftStyle]="true"></app-button>
      </div>
      <div class="col-12 col-md-6">
        <app-button *ngIf="canBeRefunded" [title]="'Cancel order' | translate" (clickEvent)="onCancelOrderClick()">
        </app-button>
        <app-button *ngIf="canChangeTimeSlot" [title]="'Change time' | translate" (clickEvent)="onChangeFlightTimeClick()">
        </app-button>
      </div>
    </div>
  </section>
</div>
<div *ngIf="slotMoveResult">
  {{ slotMoveResult }}
</div>
<div *ngIf="showSlots" class="orders-detail-change" style="display: block;">
  <app-time-slot-date-selector (nextDayClick)="nextDayClick()" (prevDayClick)="prevDayClick()"
    [selectedDate]="selectedDate" [calendarService]="bookingSlotChangeStateService"></app-time-slot-date-selector>
  <app-time-slots *ngIf="isSingle" [timeSlots]="displayTimeSlots" [isUserChangeDate]="true"
    (timeSlotSelected)="onClickTimeSlot($event)"></app-time-slots>
  <app-time-slots-event *ngIf="isEvent" class="row" [timeSlots]="displayTimeSlots"
    (timeSlotSelected)="onClickTimeSlot($event)"></app-time-slots-event>
</div>
